
<div
	class="flow-table-component"
	:style="tableWrapperStyle"
	:data-border="border"
	:data-row-gap="rowGap > 0"
	:data-column-gap="columnGap > 0"
>
	<table :style="tableStyle">
		<thead>
			<slot name="header"> </slot>
		</thead>
		<tbody>
			<slot name="body"> </slot>
		</tbody>
	</table>
</div>
